<template>
    <div>
        <h1>{{ $t('register.finished.header') }}</h1>
        <div class="ct-card">
            <section class="top-margin">
                <div
                    v-if="showMessage"
                    class="ct-text alert alert-dismissible"
                    :class="{ 'alert-success': messageType === 'success', 'alert-danger': messageType === 'error' }"
                    role="alert"
                >
                    <button type="button" class="close" v-on:click="hideAlert()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    {{ $t(messageKey) }}
                </div>
                <div
                    v-if="information.isDuplicate"
                    class="ct-text"
                    v-html="$t('register.finished.duplicate', { email: email, churchName: churchName })"
                ></div>
                <div
                    v-if="!information.isDuplicate && !forDenomination"
                    class="ct-text"
                    v-html="$t('register.finished.description', { email: email })"
                ></div>
                <div
                    v-if="!information.isDuplicate && forDenomination"
                    class="ct-text"
                    v-html="
                        $t('register.finished.descriptionDenomination', {
                            email: email,
                            denominationEmail: denominationEmail,
                            denominationName: denominationName
                        })
                    "
                ></div>
            </section>
            <section class="ct-action ct-border" v-if="!forDenomination">
                <div class="ct-row two-elements">
                    <button v-if="!information.isDuplicate" class="btn btn-primary" v-on:click="resendEmail()">
                        {{ $t('register.finished.resend') }}
                    </button>
                    <button v-if="!information.isDuplicate" class="btn btn-primary" v-on:click="toggleEmailInput()">
                        {{ $t('register.finished.editEmail') }}
                    </button>
                </div>
            </section>
            <section class="ct-action ct-border" v-if="forDenomination">
                <div class="ct-row two-elements">
                    <a :href="statusUrl">
                        <button class="btn btn-primary">{{ $t('register.finished.status') }}</button>
                    </a>
                    <a :href="againUrl">
                        <button class="btn btn-primary">{{ $t('register.finished.again') }}</button>
                    </a>
                </div>
            </section>
            <section v-if="showEmailInput && !forDenomination" class="ct-border ct-change-email">
                <div>
                    <text-input
                        :config="{ translationKey: 'label.email', required: true, id: 'email' }"
                        :input-model.sync="register.email"
                        :error="getError('email')"
                    ></text-input>
                    <div class="ct-input-element ct-align-center">
                        <button class="btn btn-primary btn-lg" type="button" v-on:click="changeEmail">
                            {{ $t('register.finished.saveEmail') }}
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import * as types from '../store/mutation-types';
import RegistrationClient from './RegistrationClient';
import TextInput from '../components/inputs/TextInput.vue';

export default {
    data: function() {
        return {
            register: {
                email: ''
            },
            messageKey: 'register.finished.resendEmailSuccess',
            showEmailInput: false,
            showMessage: false,
            messageType: 'success'
        };
    },
    components: {
        TextInput
    },
    computed: {
        information: function() {
            return this.$store.getters['registrations/registerInformation'];
        },
        showValidationsErrors: function() {
            return this.$store.getters['registrations/showValidationErrors'];
        },
        email: function() {
            return '<span class="email">' + this.information.email + '</span>';
        },
        denominationEmail() {
            return '<span class="email">' + this.information.denominationEmail + '</span>';
        },
        denominationName() {
            return this.information.denominationName;
        },
        churchName() {
            return '<span class="email">' + this.information.church + '</span>';
        },
        forDenomination() {
            return !!this.information.denomination;
        },
        statusUrl() {
            return this.information.statusUrl;
        },
        againUrl() {
            return this.information.againUrl;
        }
    },
    mounted() {
        if (typeof this.$route.params.token !== 'undefined' && this.$route.params.token !== '') {
            this.$store.dispatch('registrations/loadRegistration', { token: this.$route.params.token });
        } else {
            this.$router.push({ name: 'RegisterForm' });
        }
    },
    methods: {
        getError: function(fieldName) {
            if (this.showValidationsErrors[fieldName]) {
                return this.$i18n.t(
                    this.$store.state.registrations.validationErrors[fieldName].translationKey,
                    this.$store.state.registrations.validationErrors[fieldName].args
                );
            }

            return '';
        },

        hideAlert: function() {
            this.showMessage = false;
        },

        toggleEmailInput: function() {
            this.showEmailInput = !this.showEmailInput;
        },

        resendEmail: function() {
            let that = this;
            RegistrationClient.resendValidationMail(this.$route.params.token)
                .then(result => {
                    that.showMessage = true;
                    that.messageType = 'success';
                    that.messageKey = 'register.finished.resendEmail.success';
                })
                .catch(error => {
                    that.showMessage = true;
                    that.messageType = 'error';
                    that.messageKey = 'register.finished.resendEmail.error';
                });
        },

        changeEmail: function() {
            let that = this;
            RegistrationClient.changeEmail(this.register.email, this.$route.params.token)
                .then(result => {
                    that.showMessage = true;
                    that.messageType = 'success';
                    that.messageKey = 'register.finished.changeEmail.success';
                })
                .catch(error => {
                    that.showMessage = true;
                    that.messageType = 'error';
                    that.messageKey = 'register.finished.changeEmail.error';
                });
        }
    }
};
</script>
<style></style>
